import { COLORS3 } from '@zola/zola-ui/src/styles/emotion';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import { Title5 } from '@zola/zola-ui/src/typography/Headings';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import SmallVendorCard from '~/components/common/cards/SmallVendorCard/SmallVendorCard';

// Size of the image in the small vendor card, used to align the hed with the middle of the image.
export const CARD_IMAGE_HEIGHT = 72;
export const SCRIM_WIDTH_DESKTOP = 40;
export const SCRIM_WIDTH_MOBILE = 40;

export const SmallVendorCardShelfWrapper = styled.div`
  // for the fade out on the right
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 16px;

  &.loading > * {
    filter: blur(4px);
    opacity: 0.5;
    pointer-events: none;
  }

  ${MEDIA_QUERY_V2.DESKTOP} {
    align-items: flex-start;
    flex-direction: row;
    gap: 24px;
  } ;
`;

export const HedWrapper = styled.div`
  display: flex;
  align-items: center;

  ${MEDIA_QUERY_V2.DESKTOP} {
    height: ${CARD_IMAGE_HEIGHT}px;
  }
`;

export const Hed = styled(Title5)`
  ${MEDIA_QUERY_V2.DESKTOP} {
    max-width: 100px;
  }
`;

const Scrim = css`
  top: 0;
  width: ${SCRIM_WIDTH_DESKTOP}px;
  height: 100%;
  position: absolute;
  pointer-events: none;
`;

export const LeftScrim = styled.div`
  ${Scrim};
  left: 0;
  background: linear-gradient(to left, rgba(255, 255, 255, 0) 0%, rgba(249, 249, 249, 1) 100%);
`;

export const RightScrim = styled.div`
  ${Scrim};
  right: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, rgba(249, 249, 249, 1) 100%);
`;

export const SmallVendorCardListItem = styled(SmallVendorCard)`
  background-color: transparent !important;
  flex-shrink: 0;
  min-width: 240px;
  /* max-width: unset !important; */

  &:last-child {
    padding-right: ${SCRIM_WIDTH_DESKTOP}px;
  }
`;

const LeftScrimStyles = css`
  margin-left: -${SCRIM_WIDTH_MOBILE}px;

  ${SmallVendorCardListItem} {
    &:first-child {
      padding-left: ${SCRIM_WIDTH_DESKTOP}px;
    }
  }
`;

const SCROLLBAR_COLOR_THUMB = COLORS3.BLACK_030;
const SCROLLBAR_COLOR_TRACK = COLORS3.BLACK_010;
const SCROLLBAR_HEIGHT = 4;

export const SmallVendorCardList = styled.div<{ hasLeftScrim: boolean }>`
  // scrim adjustment: push to the edge
  ${({ hasLeftScrim }) => hasLeftScrim && LeftScrimStyles};

  display: flex;
  gap: 24px;
  padding-bottom: 12px;

  ${MEDIA_QUERY_V2.EXCLUDE_DESKTOP} {
    padding-bottom: 8px;
  }
  overflow-x: auto;

  // Reference:
  // https://developer.chrome.com/docs/css-ui/scrollbar-styling

  &::-webkit-scrollbar-thumb {
    visibility: hidden;
    background: ${SCROLLBAR_COLOR_THUMB};
  }
  &::-webkit-scrollbar-track {
    visibility: hidden;
    background: ${SCROLLBAR_COLOR_TRACK};
  }

  &:active,
  &:focus,
  &:hover {
    &::-webkit-scrollbar-thumb {
      visibility: visible;
    }
    &::-webkit-scrollbar-track {
      visibility: visible;
    }
  }

  &::-webkit-scrollbar {
    width: ${SCROLLBAR_HEIGHT}px;
    height: ${SCROLLBAR_HEIGHT}px;
    max-width: ${SCROLLBAR_HEIGHT}px;
    max-height: ${SCROLLBAR_HEIGHT}px;
  }

  &:hover {
    --fix: 1; /* This custom property invalidates styles on hover, thereby enforcing a style recomputation. This is needed to work around a bug in Safari. */
  }
`;
